<div class="media-panel">
  <!-- Header (same as Find Clips tab) -->
  <div class="media-panel__header">
    <h2 class="media-panel__title">Media</h2>
  </div>

  <div class="media-panel__body" (scroll)="onMamListScroll($event)">
    <!-- Search -->
    <div class="media-panel__section">
      <div class="media-panel__search-wrapper">
        <ichannel-input
          [placeholder]="'Search media...'"
          [value]="searchTerm"
          (valueChange)="onSearchTermChange($event)"
        ></ichannel-input>
        @if (searchTerm) {
          <button type="button" class="media-panel__search-clear" (click)="clearSearch()" aria-label="Clear search">
            &times;
          </button>
        }
      </div>
    </div>

    <!-- Language (from API: getTenantMediasLanguages, same as Scheduler) -->
    @if (languages().length > 0) {
      <div class="languages-container">
        <label class="filter-option-header">LANGUAGE:</label>
        <ul class="languages-list-container">
          <li>
            <input
              type="checkbox"
              id="media-allLanguages"
              class="input-hidden"
              (click)="onClickAllLanguages($event)"
              [checked]="checkAllLanguages"
            />
            <label for="media-allLanguages">Any Languages</label>
          </li>
          @for (lang of languages(); track lang.code; let index = $index) {
            <li>
              <input
                type="checkbox"
                [id]="'media-' + index + 'lang'"
                class="input-hidden"
                (click)="onClickLanguage($event, index)"
                [checked]="isLanguageChecked(index)"
              />
              <label [for]="'media-' + index + 'lang'">{{ lang.code.toUpperCase() }}</label>
            </li>
          }
        </ul>
      </div>
    }

    <!-- Tags (collapsed: first 4; expand/collapse like Scheduler) -->
    <div class="tag-container">
      <label class="filter-option-header">TAGS:</label>
      <ul class="tag-list-container">
        <li>
          <input
            type="checkbox"
            id="media-allTags"
            class="input-hidden"
            (click)="onClickAllTags($event)"
            [checked]="checkAllTags"
          />
          <label for="media-allTags">Any Tags</label>
        </li>
        @for (tag of tags(); track tag.id; let index = $index) {
          <li [class.display-none]="index >= 4 && !showMoreTags()">
            @if (index < 4 || showMoreTags()) {
              <input
                type="checkbox"
                [id]="'media-' + index + 'tag'"
                class="input-hidden"
                (click)="onClickTag($event, index)"
                [checked]="isTagChecked(index)"
              />
              <label [for]="'media-' + index + 'tag'">{{ tag.name }}</label>
            }
          </li>
        }
        @if (tags().length > 4 && !showMoreTags()) {
          <li class="more-tags">
            <input
              type="checkbox"
              id="media-moreTags"
              class="input-hidden"
              (click)="onToggleTags(true)"
            />
            <label for="media-moreTags"></label>
          </li>
        }
        @if (showMoreTags()) {
          <li class="less-tags">
            <input
              type="checkbox"
              id="media-lessTags"
              class="input-hidden"
              (click)="onToggleTags(false)"
            />
            <label for="media-lessTags"></label>
          </li>
        }
      </ul>
    </div>

    <!-- Sort -->
    <div class="media-panel__section media-panel__sort-section">
      <div class="media-panel__section-label">Sort By</div>
      <icn-dropdown
        class="media-panel__dropdown"
        [selectedValue]="sortBy"
        (selectedValueChange)="sortBy = $event"
        [position]="'bottom'"
        [medium]="true"
        [allowMultiple]="false"
        [textAlign]="'left'"
      >
        <icn-dropdown-item [title]="'Recently Added'" [value]="'recent'"></icn-dropdown-item>
        <icn-dropdown-item [title]="'Name (A-Z)'" [value]="'a-z'"></icn-dropdown-item>
        <icn-dropdown-item [title]="'Name (Z-A)'" [value]="'z-a'"></icn-dropdown-item>
      </icn-dropdown>
    </div>

    <!-- MAM list -->
    <div
      class="media-panel__mam-list"
      *ngIf="filteredMamItems.length > 0 && !mamLoading"
      cdkDropList
      id="mam-cards-source"
      cdkDropListConnectedTo="timeline-mam-drop-zone"
      [cdkDropListSortingDisabled]="true"
    >
      <evrideo-clipping-studio-mam-media-card
        *ngFor="let item of filteredMamItems"
        [item]="item"
        [canAddToTimeline]="canAddToTimeline"
        (addToTimeline)="onAddToTimeline($event)"
      ></evrideo-clipping-studio-mam-media-card>
    </div>

    <!-- Initial / filter reload loading (same idea as MAM Explorer overlay) -->
    <div class="media-panel__loading" *ngIf="mamLoading">
      <img
        class="media-panel__loading-icon"
        src="/assets/loader3.svg"
        alt=""
        aria-label="Loading media"
      />
      <p class="media-panel__loading-text">Loading media…</p>
    </div>

    <!-- Empty state -->
    <div class="media-panel__empty" *ngIf="filteredMamItems.length === 0 && !mamLoading">
      <div class="media-panel__empty-icon">
        <svg width="32" height="22" viewBox="0 0 21 14" fill="currentColor" fill-rule="evenodd" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.160,11.177 C19.938,11.307 19.695,11.373 19.451,11.373 C19.209,11.373 18.965,11.307 18.744,11.178 L15.537,9.299 C15.537,9.299 13.622,8.157 13.567,8.112 L13.567,5.886 C13.622,5.841 15.537,4.700 15.537,4.700 L18.743,2.821 C19.188,2.561 19.717,2.562 20.160,2.821 C20.603,3.081 20.868,3.546 20.868,4.066 L20.868,9.933 C20.868,10.452 20.603,10.918 20.160,11.177 ZM19.166,4.566 L15.537,6.693 L15.537,7.306 L19.166,9.432 L19.166,4.566 ZM13.567,1.999 L2.809,1.999 L2.809,11.999 L13.567,11.999 L13.567,9.335 C13.622,9.380 15.537,10.522 15.537,10.522 L15.537,13.999 L0.839,13.999 L0.839,-0.001 L15.537,-0.001 L15.537,3.379 C15.537,3.379 13.622,4.521 13.567,4.566 L13.567,1.999 Z"/>
        </svg>
      </div>
      <p class="media-panel__empty-text">No media found for current filters</p>
    </div>

    <div class="media-panel__loading-more" *ngIf="mamLoadingMore">
      Loading more…
    </div>
  </div>
</div>
